import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';

const Component = (props) => {
    const getClassName = (file) => {
        let className = 'context-menu';
        if (props.selectedFile && props.selectedFile.id === file.id) {
            className += ' selected';
        }
        return className;
    };

    // noinspection JSValidateTypes
    return (
        <TableContainer>
            <Table>
                <TableHead><TableRow>
                    <TableCell className="name">Название</TableCell>
                    <TableCell className="ext">Расширение</TableCell>
                    <TableCell>Ссылка</TableCell>
                </TableRow></TableHead>
                <TableBody>
                    {props.files.map((file) => (
                        <TableRow key={file.id} className={getClassName(file)}
                                  onContextMenu={props.onContextMenu(file)}
                        >
                            <TableCell className="name">{file.name}</TableCell>
                            <TableCell className="ext">{file.ext}</TableCell>
                            <TableCell><Typography noWrap={true} component='a' href={file.url} target="_blank">
                                {file.url}
                            </Typography></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    files: PropTypes.array.isRequired,
    selectedFile: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
